import React, { useEffect, useState } from "react";
import LeafletMap from "../../shared/components/LeafletMap";
import gettext from "../../shared/utils/gettext";
import SatView from "./SatView";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ElevationView from "./ElevationView";
import OtherView from "./OtherView";
import { CorrelationsView } from "./correlations/CorrelationsView.tsx";
import cropr from "../../shared/utils/cropr";

function FieldView(props) {
  const {
    setTitleText,
    toggleMeasurementLayer,
    clearMeasurementLayers,
    selectedMeasurementLayers,
    setImageLocation,
  } = props;
  const [selectedField, setSelectedField] = useState();
  const [activeMode, setActiveMode] = useState("growth");
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    setTitleText(selectedField ? selectedField.get("name") : gettext("Select a field on the map"));
  }, [setTitleText, selectedField]);
  useEffect(() => {
    clearMeasurementLayers();
    return clearMeasurementLayers;
  }, [clearMeasurementLayers]);

  return (
    <div>
      <LeafletMap
        locations={selectedMeasurementLayers
          .filter((sml) => sml.data)
          .map((sml) => ({
            type: "image",
            url: sml.data.url,
            bounds: sml.data.bounding_box,
            zoomTo: true,
            opacity: sml.opacity || 1,
            measurementLayer: sml,
            key: sml.dsUuid + sml.measurementId + sml.layerId,
          }))}
        extraLayers={true}
        showFields={true}
        updateSelectedCropfields={(cf) => setSelectedField(cf === selectedField ? null : cf)}
        selectedCropfields={selectedField ? [selectedField.get("did")] : []}
        height="calc(100vh - 115px)"
        imageZIndex={1}
      />
      {selectedField ? (
        <div
          className="bg-transparent w-480px position-absolute rounded pt-1 pb-2 pl-2 pr-3"
          style={{
            top: "20px",
            zIndex: 1000,
            left: collapsed ? "-464px" : "20px",
            transition: "all 0.2s ease",
          }}
        >
          <button
            className="btn btn-circle btn-smoke position-absolute"
            style={{ top: "45%", right: "-15px" }}
            onClick={() => setCollapsed(!collapsed)}
          >
            <i className={"far " + (collapsed ? "fa-chevron-right" : "fa-chevron-left")}> </i>
          </button>
          <Tabs activeKey={activeMode} onSelect={setActiveMode}>
            <Tab
              eventKey="growth"
              title={
                <>
                  {gettext("Growth")} <i className="far fa-chart-line"> </i>
                </>
              }
            >
              {activeMode === "growth" && (
                <SatView cropfield={selectedField} setImageLocation={setImageLocation} />
              )}
            </Tab>
            <Tab
              eventKey="height"
              title={
                <>
                  {gettext("Height")} <i className="far fa-mountains"> </i>
                </>
              }
            >
              {activeMode === "height" && (
                <ElevationView cropfield={selectedField} setImageLocation={setImageLocation} />
              )}
            </Tab>
            <Tab
              eventKey="other"
              title={
                <>
                  {gettext("Other")} <i className="far fa-tractor"> </i>
                </>
              }
            >
              {activeMode === "other" && (
                <OtherView
                  cropfield={selectedField}
                  toggleMeasurementLayer={toggleMeasurementLayer}
                  clearMeasurementLayers={clearMeasurementLayers}
                  selectedMeasurementLayers={selectedMeasurementLayers}
                />
              )}
            </Tab>
            {cropr.getConfig("experiments", "correlation_tool", true) ? (
              <Tab
                eventKey="Correlations"
                title={
                  <>
                    {gettext("Correlations")} <i className="far fa-compass"> </i>
                  </>
                }
              >
                {activeMode === "Correlations" && (
                  <CorrelationsView
                    cropfield={selectedField}
                    clearMeasurementLayers={clearMeasurementLayers}
                    toggleMeasurementLayer={toggleMeasurementLayer}
                  />
                )}
              </Tab>
            ) : null}
          </Tabs>
        </div>
      ) : null}
    </div>
  );
}

export default FieldView;
